// function for get data list such as Bank list, Status list
import clientHttp from './ClientHttp';

export async function getBankList() {
    console.log('call getBankList')
    let token = localStorage.getItem('token')

    let list = []
    await clientHttp.get('list/v1/bankname', {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getBankList] get bank list success')
            list = response.data.data
            return list
        } else {
            console.log('[getBankList] get bank list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getBankList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getBankList] no authorize')
        } else {
            console.log('[getBankList] get bank list failed: ' + err.message)
        }
    })

    return list
}

export async function getBankAccountList() {
    console.log('call getBankAccountList')
    let token = localStorage.getItem('token')

    let list = []
    await clientHttp.get('list/v1/bankaccount', {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getBankAccountList] get bank account list success')
            list = response.data.data
            return list
        } else {
            console.log('[getBankAccountList] get bank account list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getBankAccountList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getBankAccountList] no authorize')
        } else {
            console.log('[getBankAccountList] get bank account list failed: ' + err.message)
        }
    })

    return list
}

export async function getBankNoList(bank) {
    console.log('call getBankNoList')
    let token = localStorage.getItem('token')

    const formData = {
        bank: bank
    }

    let list = []
    await clientHttp.post('list/v1/bankno', formData, {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getBankNoList] get bank no list success')
            list = response.data.data
            return list
        } else {
            console.log('[getBankNoList] get bank no list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getBankNoList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getBankNoList] no authorize')
        } else {
            console.log('[getBankNoList] get bank no list failed: ' + err.message)
        }
    })

    return list
}

export async function getBankFileStatusList() {
    console.log('call getBankFileStatusList')
    let token = localStorage.getItem('token')

    let list = []
    await clientHttp.get('list/v1/bankfilestatus', {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getBankFileStatusList] get bank file status list success')
            list = response.data.data
            return list
        } else {
            console.log('[getBankFileStatusList] get bank file status list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getBankFileStatusList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getBankFileStatusList] no authorize')
        } else {
            console.log('[getBankFileStatusList] get bank list failed: ' + err.message)
        }
    })

    return list
}

export async function getOrderStatusList() {
    console.log('call getOrderStatusList')
    let token = localStorage.getItem('token')

    let list = []
    await clientHttp.get('list/v1/orderstatus', {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getOrderStatusList] get order status list success')
            list = response.data.data
            return list
        } else {
            console.log('[getOrderStatusList] get order status list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getOrderStatusList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getOrderStatusList] no authorize')
        } else {
            console.log('[getOrderStatusList] get order failed: ' + err.message)
        }
    })

    return list
}

export async function getPaymentStatusList() {
    console.log('call getPaymentStatusList')
    let token = localStorage.getItem('token')

    let list = []
    await clientHttp.get('list/v1/paymentstatus', {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getPaymentStatusList] get order status list success')
            list = response.data.data
            return list
        } else {
            console.log('[getPaymentStatusList] get order status list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getPaymentStatusList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getPaymentStatusList] no authorize')
        } else {
            console.log('[getPaymentStatusList] get order failed: ' + err.message)
        }
    })

    return list
}

export async function menuPermissionHasAccess(menuList, pathname) {
    let result = false
    //console.log('check permission of pathname: ' + pathname)
    for (let i = 0; i < menuList.length; i++) {
        //console.log('compare pathname: ' + menuList[i].pathname + ', ' + menuList[i].roleid)
        if (menuList[i].pathname === pathname) {
            if (menuList[i].roleid > 0) {
                result = true
            }
            break
        }
    }
    return result
}

export async function menuPermissionHasUpdate(menuList, pathname) {
    let result = false
    //console.log('check permission of pathname: ' + pathname)
    for (let i = 0; i < menuList.length; i++) {
        //console.log('compare pathname: ' + menuList[i].pathname + ', ' + menuList[i].writeflag)
        if (menuList[i].pathname === pathname) {
            if (menuList[i].writeflag === 'Y') {
                result = true
            }
            break
        }
    }
    return result
}

export async function getCcTypeList(groupId) {
    console.log('call getCcTypeList')
    let token = localStorage.getItem('token')

    const formData = {
        groupId: groupId
    }
    let list = []
    await clientHttp.post('list/v1/cctypelist', formData, {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(response => {
        console.log('response status: ' + response.status)
        if (response.data.status === 'success') {
            console.log('[getCcTypeList] get bank list success')
            list = response.data.data
            return list
        } else {
            console.log('[getCcTypeList] get bank list failed: ' + response.data.message)
        }

    }).catch(err => {
        console.log('[getCcTypeList] error: ', err.message)
        if (err.response.status === 401 || err.response.status === 403) {
            console.log('[getCcTypeList] no authorize')
        } else {
            console.log('[getCcTypeList] get bank list failed: ' + err.message)
        }
    })

    return list
}
